var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#224870;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visual"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,6.23l25.7-.96c25.6-.96,77-2.89,128.5-3.83,51.5-.95,103.1-.89,154.6.79,51.5,1.68,102.9,5,154.2,5.68,51.3.7,102.7-1.23,154-3.31,51.3-2.08,102.7-4.3,154.2-4.26,51.5.06,103.1,2.37,154.6,2.7,51.5.33,102.9-1.36,128.5-2.2l25.7-.85v17.5H0V6.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveStart);
export default __webpack_public_path__ + "static/media/wave-start.7ae05e85c2c8cd101b6ad10716506019.svg";
export { ForwardRef as ReactComponent };